
import $ from 'jquery';
import Vue from 'vue';
import { Component, Provide, Watch } from 'vue-property-decorator';
import ExternalUserSelectModalTab from './ExternalUserSelectModal/ExternalUserSelectModalTab';
import TabButton from '../../util/TabButton';
import TabContacts from './ExternalUserSelectModal/TabContacts';

@Component({
  components: {
    ExternalUserSelectModalTab,
    TabButton,
    TabContacts,
  },
})
export default class ExternalUserSelectModal extends Vue {
  slottedTabs: ExternalUserSelectModalTab[] = [];
  tab: string = '';

  get uid(): string {
    return (this as any)._uid;
  }

  public open(): void {
    this.slottedTabs.forEach(tab => tab.clear());
    $(this.$refs.modal!).modal('show');
  }

  public dismiss(): void {
    $(this.$refs.modal!).modal('hide');
  }

  onAdd(): void {
    // Find the currently active tab directly by matching the active tab ID
    const activeTab = this.slottedTabs.find(t => t.id === this.tab);

    // Fall back to filtering visible tabs if needed
    const selectedUsers = activeTab 
      ? [...activeTab.selectedUsers]
      : this.slottedTabs.filter(e => e.visible).flatMap(e => e.selectedUsers);

    this.$emit('selected', selectedUsers);
  }

  @Provide()
  addTab(tab: ExternalUserSelectModalTab) {
    if (!this.slottedTabs.some(t => t.id === tab.id || t === tab)) { // do not double register
      this.slottedTabs.push(tab);
    }
  }

  @Provide()
  removeTab(tab: ExternalUserSelectModalTab) {
    const index = this.slottedTabs.findIndex(t => t === tab);
    if (index >= 0) {
      this.slottedTabs.splice(index, 1);
    }
  }

  @Watch('tab')
  @Watch('slottedTabs')
  private tabChanged(): void {
    //select first tab if none selected
    if (!this.tab && this.slottedTabs.length > 0) {
      this.tab = this.slottedTabs[0].id;
    }

    //update tab visibility
    this.slottedTabs.forEach(tab => {
      const newVisible = tab.id === this.tab;
      if (tab.visible !== newVisible) { //only set when different, prevent endless event looping
        tab.visible = newVisible;
      }
    });
  }
}
